<!-- List -->
<ng-template [ngIf]="isVisualizacaoModoList">
    <sgt-cliente-analise-mercado-cliente-list
        #clienteList
        visualizacaoStorageKey="clienteAnaliseMercadoClienteListVisualizacaoClassificacao"
        [filter]="filter">
    </sgt-cliente-analise-mercado-cliente-list>
</ng-template>
